import { RegionType, } from '@wix/shoutout-email-model-v3';
export function shouldShowAd(showAd, regions, _experiments, message) {
    if (showAd === true) {
        return true;
    }
    else {
        if (message && message.messageType === 'Transactional') {
            return false;
        }
        const footerRegion = regions?.find((r) => r.type === RegionType.Footer);
        if (footerRegion) {
            return footerRegion.data.enabledWixBranding ?? false;
        }
        return false;
    }
}
//# sourceMappingURL=show-ad.js.map